/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, session: NonNullable<unknown> }} Plan_Edit_Added_ToastInputs */

const en_us2_plan_edit_added_toast = /** @type {(inputs: Plan_Edit_Added_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} added to the end of ${i?.session}`)
};

const pt_br2_plan_edit_added_toast = /** @type {(inputs: Plan_Edit_Added_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} entrou no fim do ${i?.session}`)
};

const es_419_plan_edit_added_toast = /** @type {(inputs: Plan_Edit_Added_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} se agregó al final de ${i?.session}`)
};

const pt_pt2_plan_edit_added_toast = /** @type {(inputs: Plan_Edit_Added_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} entrou no fim do ${i?.session}`)
};

const fr_fr2_plan_edit_added_toast = /** @type {(inputs: Plan_Edit_Added_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} ajouté à la fin de ${i?.session}`)
};

const de_de2_plan_edit_added_toast = /** @type {(inputs: Plan_Edit_Added_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} am Ende von ${i?.session} hinzugefügt`)
};

const it_it2_plan_edit_added_toast = /** @type {(inputs: Plan_Edit_Added_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} aggiunto alla fine di ${i?.session}`)
};

/**
* | output |
* | --- |
* | "{name} added to the end of {session}" |
*
* @param {Plan_Edit_Added_ToastInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_edit_added_toast = /** @type {((inputs: Plan_Edit_Added_ToastInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Edit_Added_ToastInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_edit_added_toast(inputs)
	if (locale === "es-419") return es_419_plan_edit_added_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_edit_added_toast(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_edit_added_toast(inputs)
	if (locale === "de-DE") return de_de2_plan_edit_added_toast(inputs)
	if (locale === "it-IT") return it_it2_plan_edit_added_toast(inputs)
	return en_us2_plan_edit_added_toast(inputs)
});
export { plan_edit_added_toast as "plan-edit.added_toast" }